import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe('pk_live_51TPVJMRsLumT6qbb337CFlgr6DttYBcSjRI3BRjZviUGPuhTETyfIzHSpchNyC1kZvhXJElaE6Gkgc9UqiBxYn6K00viVhYvws');

export const PRICES = {
  day: 'price_1TgY0jRsLumT6qbb82F5URrh',
  month: 'price_1TgY0iRsLumT6qbbW2BO4AnK',
  year: 'price_1TgY0hRsLumT6qbbFgz2q4Pu',
  business: 'price_1TbSU0RxHnpyvLoZB7BkONeT',
};